import { t } from "../i18n";

export function Footer() {
  return (
    <footer class="footer">
      <span>{t("unofficial")} Podaci su preuzeti s javnih stranica fakulteta. Termine uvijek provjerite kod nastavnika.</span>
      <span><a href="/about">{t("about")}</a> · <a href="mailto:me@qoobes.dev?subject=Slu%C5%A1am">kontakt / uklanjanje podataka</a></span>
    </footer>
  );
}
